import { useState, useCallback } from "react"
import { dataService } from "utils/dataService"

const MAX_RETRIES = 3
const RETRY_BASE_DELAY_MS = 100

export const useConsent = () => {
  const [consent, setConsent] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [hasFetched, setHasFetched] = useState(false)
  const [error, setError] = useState(null)

  const fetchConsent = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    let lastErr
    for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
      try {
        const { data } = await dataService.Consent.getAppearanceAnalysisConsent()
        const hasConsented = data?.consent ?? false
        setConsent(hasConsented)
        setHasFetched(true)
        setIsLoading(false)
        return hasConsented
      } catch (err) {
        lastErr = err
        console.error(`[Consent] Fetch attempt ${attempt + 1} failed`, err)
        await new Promise((resolve) => setTimeout(resolve, Math.pow(2, attempt) * RETRY_BASE_DELAY_MS))
      }
    }
    setError(lastErr)
    setIsLoading(false)
  }, [])

  const upsertConsent = useCallback(async (hasOptedIn) => {
    setIsLoading(true)
    setError(null)
    try {
      await dataService.Consent.setAppearanceAnalysisConsent({ hasOptedIn })
      setConsent(hasOptedIn)
    } catch (err) {
      setError(err)
      console.error("Error: failed to upsert consent", err)
      throw err
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { consent, isLoading, hasFetched, error, fetchConsent, upsertConsent }
}
